import '@/assets/main.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import '@/assets/vue-multiselect-custom.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { readConfig } from '@/composables/useReadConfig'
import App from '@/App.vue'

const app = createApp(App)
const gmrConfig = readConfig()
app.use(createPinia())
app.provide('gmrConfig', gmrConfig)

app.mount('#app')
